import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M11.333 3.667a3.666 3.666 0 0 0-3.666 3.666A3.666 3.666 0 0 0 11.333 11 3.666 3.666 0 0 0 15 7.333a3.666 3.666 0 0 0-3.667-3.666m0 8.25C8.886 11.917 4 13.145 4 15.583v2.75h14.667v-2.75c0-2.438-4.886-3.666-7.334-3.666"
    }, null, -1)
  ])))
}
export default { render: render }